import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReleaseInfo from "../../components/ReleaseInfo";
import RecordingDetails from "../Recordings/RecordingDetails";
import { Release } from "../Analytics/Recorded";
import { useReleaseService } from "../../api/releaseService";
import { useRecordedService } from "../../api/recordedService";

export const ReleaseDetails: React.FC = () => {
  const { releaseId } = useParams<{ releaseId: string }>();
  const { id } = useParams<{ id: string }>();
  const [selectedRelease, setSelectedRelease] = useState<
    Release | null | undefined
  >(undefined);
  const [selectedRecordings, setSelectedRecordings] = useState<Release[]>([]);
  const { recorded, recordedLoading } = useRecordedService();
  useEffect(() => {
    setSelectedRelease(
      Array.isArray(recorded)
        ? recorded.find((release) => release.id === parseInt(id ?? ""))
        : null
    );
  }, [recorded]);

  useEffect(() => {}, [recorded]);

  if (!selectedRelease) {
    return <div>Run not found</div>;
  }

  return (
    <div className="release-details">
      <ReleaseInfo release={selectedRelease} />
      {selectedRelease?.recordings &&
        selectedRelease.recordings.map((recording: Recording) => (
          <RecordingDetails recording={recording} />
        ))}
    </div>
  );
};
